// Components
import WelcomeBonusCardItem from "components/molecules/WelcomeBonusCardItem";

// Constants
import { WELCOME_BONUS_LIST_ITEM } from "constants/bonus";

// Hooks
import useTranslate from "hooks/useTranslate";
import Close from "assets/icons/glory/close_white.svg?react";
import useFormatNumber from "../../../hooks/useFormatNumber";

// Icons

// Types
import { BonusType } from "../../../types/info";

import "./styles.sass";

type WelcomeBonusCardBackProps = {
  onClick: () => void;
  bonusData: BonusType;
};

const WelcomeBonusCardBack = (props: WelcomeBonusCardBackProps) => {
  const { onClick, bonusData } = props;
  const { min, max, freeSpins } = bonusData;
  const t = useTranslate();
  const formatNumber = useFormatNumber();

  return (
    <div className="WelcomeBonusCardBack">
      <div className="WelcomeBonusCardBack-header">
        {t("bonus.welcome.card.name")}
        <Close
          className="WelcomeBonusCardBack-header__close"
          // eslint-disable-next-line react/jsx-handler-names
          onClick={onClick}
        />
      </div>
      <div className="WelcomeBonusCardBack-content">
        <div className="WelcomeBonusCardBack-content__description">
          <span>{t("bonus.welcome.card.deposit.from")}</span> &nbsp;
          <span>{formatNumber(min, 0, true)}</span>
        </div>
        <div className="WelcomeBonusCardBack-content-list">
          {WELCOME_BONUS_LIST_ITEM.map((bonus) => (
            <WelcomeBonusCardItem
              key={bonus.id}
              bonus={bonus}
              min={min}
              max={max}
              freeSpins={freeSpins}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeBonusCardBack;
